(function () {
    'use strict';

    angular.module('product')
        .controller('InpostLockerLimitController', InpostLockerLimitController);

    InpostLockerLimitController.$inject = ['inpostLockerLimitDataSrvc', 'notificationSrvc', 'inpostLockerLimitMessagesConst', 'errorNotificationSrvc', 'checkModelPermissionsSrvc', 'inpostLockerLimitPermissionsConst'];

    function InpostLockerLimitController(inpostLockerLimitDataSrvc, notificationSrvc, inpostLockerLimitMessagesConst, errorNotificationSrvc, checkModelPermissionsSrvc, inpostLockerLimitPermissionsConst) {
        var self = this;

        self.canChange = !checkModelPermissionsSrvc.isDenied(inpostLockerLimitPermissionsConst.update);

        self.serverErrors = {
            height: [],
            width: [],
            length: [],
            max_weight: [],
            nonFieldErrors: []
        };

        self.limitData = {};

        // same order as InPost gives the locker size: height x width x length
        self.inlineInputFields = ['height', 'width', 'length'].map(function (prop, index) {
            return {
                prop: prop,
                type: 'number',
                title: ['Wysokość', 'Szerokość', 'Długość'][index],
                isRequired: true,
                isDisabled: !self.canChange,
                minValue: 1,
                onChange: cleanErrors
            };
        });

        self.updateLimit = updateLimit;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getLimit();
        }

        function getLimit() {
            return inpostLockerLimitDataSrvc.get().$promise.then(function (response) {
                self.limitData = response;
                return response;
            });
        }

        function updateLimit() {
            if (!self.canChange) {
                return;
            }
            inpostLockerLimitDataSrvc.update({}, {
                height: self.limitData.height,
                width: self.limitData.width,
                length: self.limitData.length,
                max_weight: self.limitData.max_weight
            }).$promise.then(
                function (response) {
                    self.limitData = response;
                    notificationSrvc.notification('success', inpostLockerLimitMessagesConst.update);
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();